//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {get_cookie} from 'common';
import {atom} from 'recoil';
import {IAlertState, IOrder, IUserInfo} from 'types';

//---------------------------------------------------------
// Atoms
//---------------------------------------------------------
export const order_list_atom = atom({
	key: 'order_list_atom',
	default: [] as IOrder[],
});

export const exchange_name_atom = atom({
	key: 'exchange_name_atom',
	default: get_cookie('exchange') ?? 'mock',
});

export const currency_atom = atom({
	key: 'currency_atom',
	default: 'KRW',
});

export const asset_atom = atom({
	key: 'asset_atom',
	default: 'BTC',
});

export const user_info_atom = atom({
	key: 'user_info_atom',
	default: {
		id: '',
		username: '',
	} as IUserInfo,
});

export const alert_atom = atom<IAlertState>({
	key: 'alert_atom',
	default: {
		open: false,
		message: '',
		severity: 'info',
	},
});
